

import React, {useRef, useState} from 'react';
import ReactDOM from 'react-dom/client';
import { useEffect } from 'react';
import { sk, cs, enGB, de } from 'date-fns/locale'
import { format, set, isSunday, isWeekend } from 'date-fns';
import moment from 'moment';

import '../../react-calendar/src/styles.scss'; // main style file
import '../../react-calendar/src/theme/default.scss'; // theme css file

import { DateRange } from '../../react-calendar/src/components/DateRange/index.js';

import OfficeSelector from "@/modules/front/OfficeSelector";
import VariantSelector from "@/modules/front/VariantSelector";
import {AddToCartButton} from "./AddToCartButton";


const ItemDatePicker = ({itemId, from, to, ...props}) => {
  let showModal = props.showModal ? props.showModal : false;

  const [deviceSize, changeDeviceSize] = useState(window.innerWidth);
  const [possibleLengths, setPossibleLengths] = useState(null);
  const [allowNext, setAllowNext] = useState(false);
  const [disabledDates, setDisabledDates] = useState([]);
  const [partlyDisabledDates, setPartlyDisabledDates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [disabledDatesCache, setDisabledDatesCache] = useState([]);
  const [shownDate, setShownDate] = useState(new Date());
  const [officeId, setOfficeId] = useState(props.office);
  const [productId, setProductId] = useState(itemId);

  const [minLength, setMinLength] = useState(1);
  const lockOffice = props.lockOffice;

  const [minLengthError, setMinLengthError] = useState(null);

  const calendarDataControllerRef = React.useRef(null);
  const maxReservationLengthControllerRef = React.useRef(null);


  const [state, setState] = useState(
    {
      startDate: from ? new Date(moment(from, 'DD.MM.YYYY').format('YYYY-MM-DD')) : new Date(),
      endDate: to ? new Date(moment(to, 'DD.MM.YYYY').format('YYYY-MM-DD')) : new Date(),
      key: 'selection',
    }
  );

  const isFridayToMondayRental = (start, end) => {
    if (!start || !end) return false;
    const diffDays = moment(end).startOf('day').diff(moment(start).startOf('day'), 'days');
    return diffDays === 3 && start.getDay() === 5;
  };

  const showWeekendRentalNotice = !!props.weekendRentalNotice && isFridayToMondayRental(state.startDate, state.endDate);

  useEffect(() => {
    if (state && state.startDate && state.endDate) {
      const length = moment(state.endDate).diff(moment(state.startDate), 'days')+1;

      if (length < minLength) {
        setMinLengthError("Minimální délka rezervace je " + minLength + (minLength === 1 ? " den." : minLength < 5 ? " dny." : " dní."));
        if (props.onDateConfirmed) props.onDateConfirmed(null, null, props.officeId);
      }
      else {
        setMinLengthError(null);

          if (props.onDateConfirmed && state.startDate && state.endDate) {
              props.onDateConfirmed(state.startDate, state.endDate, props.officeId);
          }
      }
    }
  }, [state.startDate, state.endDate, minLength]);

  useEffect(() => {
    const resizeW = () => changeDeviceSize(window.innerWidth);
    window.addEventListener("resize", resizeW); // Update the width on resize
    return () => window.removeEventListener("resize", resizeW);
  });

  let variants = [];
  if (props.variants) {
      variants = Object.keys(props.variants).map((key) => props.variants[key]);
  }




  const fetchCalendarData = (startMonth, refresh = false) => {

    // Do not return to range focus if user is changing month
    if (startMonth) {
      setShownDate(moment(startMonth).toDate());
    }

    if (startMonth) {
      var month = moment(startMonth).format('YYYY-MM');
      const nextMonth = moment(startMonth).add(1, 'months').format('YYYY-MM');

      if (disabledDatesCache.includes(month)) {
        if (disabledDatesCache.includes(nextMonth)) {
          return;
        }
      }
    }
    else {
      var month = moment().format('YYYY-MM');
    }

    
    setLoading(true);

    if (calendarDataControllerRef.current) {
        console.log('aborting');
        calendarDataControllerRef.current.abort();
    }
    calendarDataControllerRef.current = new AbortController();

    const endPoint = window.api.product.getCalendarData;
    const url = endPoint + '?productId=' + productId + '&dateFrom=' + month + '&officeId=' + officeId;

    fetch(url, { signal: calendarDataControllerRef.current.signal })
      .then(response => response.json())
      .then(data => {
        var dd = data.disabledDates.map(function(date) {
          let d=  new Date(date)
          // Set time to 00:00:00 - possible bug in react-calendar
          d.setHours(0,0,0,0);
          return d;

        });

        var pdd = data.partlyDisabledDates.map(function(date) {
          return date;
        });

        if (refresh) {
            setDisabledDatesCache([...data.months]);
            setDisabledDates([...dd]);
            setPartlyDisabledDates([...pdd]);
        }
        else {
            setDisabledDatesCache([...disabledDatesCache, ...data.months]);
            setDisabledDates([...disabledDates, ...dd]);
            setPartlyDisabledDates([...partlyDisabledDates, ...pdd]);
        }
        setLoading(false);
      })
        .catch((error) => {
            if (error.name === 'AbortError') {
                console.log('Fetch aborted due to component update');
            } else {
                console.error(error);
            }
        });
  }

  useEffect(() => {
      fetchCalendarData();
  }, []);

    useEffect(() => {
        fetchCalendarData(null, true);
    }, [productId]);


  // Get possible lengths
  useEffect(() => {
    if (state && state.startDate) {
      const endPoint = window.api.product.getMaxReservationLength;
      const url = endPoint + '?productId=' + productId + '&date=' + moment(state.startDate).format('YYYY-MM-DD') + '&officeId=' + officeId;

    if (!state.startDate) return;

    if (maxReservationLengthControllerRef.current) {
        console.log('aborting');
        maxReservationLengthControllerRef.current.abort();
    }

    maxReservationLengthControllerRef.current = new AbortController();


    setPossibleLengths(null);
    setLoading(true);
    fetch(url, { signal: maxReservationLengthControllerRef.current.signal })
      .then(response => response.json())
      .then(data => {
        setPossibleLengths(data.possibleLengths);
        if (data.minLength) {
          setMinLength(data.minLength);
        }
        setLoading(false);
      })
        .catch((error) => {
            if (error.name === 'AbortError') {
                console.log('Fetch aborted due to component update');
            } else {
                console.error(error);
            }
        });
    }
  }, [state.startDate, officeId, productId]);

  
  // Snap endDate to closest valid length when startDate changes or possibleLengths load.
  // Deps exclude state.endDate intentionally — snap only on new startDate, not on every endDate change.
  useEffect(() => {
    if (possibleLengths && possibleLengths.length > 0) {
      const length = moment(state.endDate).diff(moment(state.startDate), 'days') + 1;
      if (!possibleLengths.includes(length)) {
        const closestLength = possibleLengths.reduce((prev, curr) =>
          Math.abs(curr - length) < Math.abs(prev - length) ? curr : prev
        );
        setState(prev => ({
          ...prev,
          endDate: moment(prev.startDate).add(closestLength - 1, 'days').toDate()
        }));
      }
    }
  }, [state.startDate, possibleLengths]);

  // Update allowNext when possibleLengths or selected dates change.
  // On null (loading), preserve the previous allowNext to avoid flash of "not available".
  useEffect(() => {
    if (possibleLengths === null) return;
    if (possibleLengths.length === 0) {
      setAllowNext(false);
      return;
    }
    if (state && state.startDate && state.endDate) {
      const length = moment(state.endDate).diff(moment(state.startDate), 'days') + 1;
      setAllowNext(possibleLengths.includes(length));
    }
  }, [possibleLengths, state.startDate, state.endDate]);

  useEffect(() => {
      fetchCalendarData(null, true);
  }, [officeId]);

  useEffect(() => {
      if (props.onChange) {
          props.onChange({
              allowNext: allowNext,
              startDate: state.startDate,
              endDate: state.endDate
          })
      }
    }, [allowNext, state.startDate, state.endDate]);
  // End get possible lengths

    const handleVariantChange = (variant) => {
        setProductId(variant);
    };

var someInfo = null;
    if (!officeId) {
        someInfo  = <>
            <OfficeSelector offices={props.offices} office={props.office} lockOffice={lockOffice} onOfficeChange={(o) => handleOfficeChange(o)} />
            <div className="">
                <div className='d-flex justify-content-md-end justify-content-center align-items-center flex-column flex-md-row'>
                    <PriceInfo startDate={state.startDate} endDate={state.endDate} productId={productId} />
                    <AddToCartButton disabled={true} addToCartLabel={props.addToCartLabel} onDateConfirmed={props.onDateConfirmed} productId={productId} showModal={showModal} />
                </div>
            </div>
        </>

    }
    else {
         someInfo = allowNext ? (
            <>
                <div>
                    <OfficeSelector offices={props.offices} office={props.office} lockOffice={lockOffice} onOfficeChange={(o) => handleOfficeChange(o)} />
                    <VariantSelector variants={variants} variant={productId} onVariantChange={handleVariantChange} />
                </div>
                <div className='d-flex justify-content-md-end justify-content-center align-items-center flex-column flex-md-row'>
                    <PriceInfo startDate={state.startDate} endDate={state.endDate} officeId={officeId} productId={productId} />
                    <AddToCartButton startDate={state.startDate} endDate={state.endDate} officeId={officeId} addToCartLabel={props.addToCartLabel} onDateConfirmed={props.onDateConfirmed} productId={productId} showModal={showModal} />
                </div>
            </>

        ) : (
            <>
                <div>
                    <OfficeSelector offices={props.offices} office={props.office} lockOffice={lockOffice} onOfficeChange={(o) => handleOfficeChange(o)} />
                    <VariantSelector variants={variants} variant={productId} onVariantChange={handleVariantChange} />
                </div>
                <div className='d-flex justify-content-md-end justify-content-center align-items-center flex-column flex-md-row'>
                    <div className='text-danger mb-3' style={{marginRight: "1em"}}>{window.translations.notAvailable}</div>
                    <AddToCartButton disabled={true} addToCartLabel={props.addToCartLabel} onDateConfirmed={props.onDateConfirmed} productId={productId} showModal={showModal} />
                </div>
            </>

        );
    }




  const minDate = (() => {
      const now = new Date();
      const advance = parseInt((window.reservationConfig && window.reservationConfig.minBookingAdvance) || 0);
      const cutoffHour = window.variables && window.variables.orderNextDayCutoffHour;
      const cutoffDaysAfter = (window.variables && window.variables.orderCutoffDaysAfter) || 2;
      let daysToAdd = advance;
      if (cutoffHour != null && now.getHours() >= cutoffHour) {
          daysToAdd = Math.max(daysToAdd, cutoffDaysAfter);
      }
      return new Date(now.getFullYear(), now.getMonth(), now.getDate() + daysToAdd);
  })();

  const customDayContent = (day) => {
    var className = "";
    if (partlyDisabledDates.includes(moment(day).format('YYYY-MM-DD')) && day >= minDate) {
      className = "partly-disabled";
    }
    return (
      <div className={className}>
        <span>{format(day, "d")}</span>
      </div>
    )
  }

  const disabledDay = (() => {
    if (document.body.classList.contains('allowed-pickup-return-days-workdays')) {
      return (day) => isWeekend(day);
    }
    if (document.body.classList.contains('allowed-pickup-return-days-workdays-sat')) {
      return (day) => isSunday(day);
    }
    return () => false;
  })();

  let className = loading ? 'componentLoading' : '';
  let locale = null;
  if (props.locale == 'en' || props.locale =='en_EN') {
      locale = enGB;
  }
  else if (props.locale == 'de' || props.locale =='de_DE') {
      locale = de;
  }
  else if (props.locale == 'sk' || props.locale =='sk_SK') {
      locale = sk;
  }
  else {
      locale = cs;
  }

  const handleOfficeChange = (office) => {
      setOfficeId(office.id);
  }
  // Get bs primary color
  let color_ = getComputedStyle(document.documentElement).getPropertyValue('--bs-primary');
  const [color, setColor] = useState(color_);

  window.addEventListener('load', () => {
    setColor(getComputedStyle(document.documentElement).getPropertyValue('--bs-primary'));
  });

  if (!officeId) {
      className += ' disabled-choose-office';
  }


  return (
    <div className={className}>
        <div
            className="legend d-flex justify-content-md-end justify-content-center align-items-center flex-row flex-wrap mb-3 mt-2">
            <div className="d-flex align-items-center py-1 me-1">
                <div className="freeDay border px-2">
                    <small>1</small>
                </div>
                <div className="px-2">
                    <small>{window.translations.calendarLegend.free}</small>
                </div>
            </div>
            <div className="d-none align-items-center py-1 me-1 weekendDayLegendWrapper">
                <div className="weekendDay border px-2">
                    <small>1</small>
                </div>
                <div className="px-2">
                    <small>{window.translations.calendarLegend.weekend}</small>
                </div>
            </div>
            <div className="d-flex align-items-center py-1 me-1">
                <div className="selectedDay border px-2">
                    <small>1</small>
                </div>
                <div className="px-2">
                    <small>{window.translations.calendarLegend.selected}</small>
                </div>
            </div>
            <div className="d-flex align-items-center py-1 me-1">
                <div className="disabledDay border px-2">
                    <small>1</small>
                </div>
                <div className="px-2">
                    <small>{window.translations.calendarLegend.disabled}</small>
                </div>
            </div>
            {partlyDisabledDates.length > 0 && (
                <div className="d-flex align-items-center py-1 me-1">
                    <div className="partlyDisabledDay border px-2">
                        <small>1</small>
                    </div>
                    <div className="px-2">
                        <small>{window.translations.calendarLegend.partlyDisabled}</small>
                    </div>
                </div>
            )}
    </div>
        {minLengthError ? <div className="alert alert-warning">{minLengthError}</div> : null}
        {showWeekendRentalNotice ? <div className="alert alert-warning small" dangerouslySetInnerHTML={{__html: props.weekendRentalNotice}} /> : null}
      <DateRange
        onChange={item => setState(item.selection)}
        locale={locale}
        showSelectionPreview={true}
        moveRangeOnFirstSelection={false}
        months={props.calendarMonths || 2}
        ranges={[state]}
        direction={deviceSize < 760 ? "vertical" : "horizontal"}
        disabledDates={disabledDates}
        disabledDay={disabledDay}
        showMonthAndYearPickers={false}
        minDate={minDate}
        possibleLengths={possibleLengths}
        dayContentRenderer={customDayContent}
        dragSelectionEnabled={false}
        onShownDateChange={fetchCalendarData}
        shownDate={shownDate}
        minLength={minLength}
        fixedLength={props.fixedLength}
        color={color}
        rangeColors={[color]}


        // fix - calendar is focusing on selected range on every render:
      
        
      />
      <div className="d-flex justify-content-between align-items-center some-info">
      {props.hideInfo ? null : someInfo}
      </div>
    </div>
  );
}

const PriceInfo = (props) => {
  if (!props.startDate || !props.endDate ) {
    return null;
  }

  const [loading, setLoading] = useState(true);

  const endPoint = window.api.product.getPricing;

  const dateFromFormatted = moment(props.startDate).format('DD. MM. YYYY');
  const dateToFormatted = moment(props.endDate).format('DD. MM. YYYY');



  const [price, setPrice] = useState(0);

  const [displayUnit, setDisplayUnit] = useState(null);
  const [vatMode, setVatMode] = useState(null);
  const [priceVatFormatted, setPriceVatFormatted] = useState(null);
  const [emphasizeVatPrice, setEmphasizeVatPrice] = useState(false);


  const controller = useRef(null);

  const [quantity, setQuantity] = useState({totalQuantity: null, availableQuantity: null});
  const [displayAvailableQuantities, setDisplayAvailableQuantities] = useState(false);

  useEffect(() => {
    setLoading(true);


      // Flag to ensure state is updated only if the component is still mounted
      let isMounted = true;

      const fetchData = () => {
          if (controller.current) {
              console.log('aborting');
              controller.current.abort();
          }

        controller.current = new AbortController();
          let url1 = endPoint + '?id=' + props.productId + '&dateTo=' + moment(props.endDate).format('YYYY-MM-DD') + '&dateFrom=' + moment(props.startDate).format('YYYY-MM-DD') + '&officeId=' + props.officeId + '&locale=' + window.variables.locale;
          fetch(url1, { signal: controller.current.signal })
              .then((response) => response.json())
              .then((data) => {
                  // Only update state if the component is still mounted and the request was not aborted
                  if (isMounted) {
                      console.log(data);
                      setLoading(false);
                      setPrice(data.priceTotalFormatted);
                      setQuantity({totalQuantity: data.totalQuantity, availableQuantity: data.availableQuantity});
                      setDisplayAvailableQuantities(data.displayAvailableQuantities);
                      setDisplayUnit(data.displayUnit);
                      setVatMode(data.vatMode);
                      setPriceVatFormatted(data.priceTotalVatFormatted);
                      setEmphasizeVatPrice(!!data.emphasizeVatPrice);
                  }
              })
              .catch((error) => {
                  // If the fetch was aborted, handle it silently
                  if (error.name === 'AbortError') {
                      console.log('Fetch aborted due to component update');
                  } else {
                      console.error(error);
                      // Retry the fetch if the error is not abortion-related
                      if (isMounted) {
                          setTimeout(() => {
                              fetchData();
                          }, 1000);
                      }

                  }
              });
    };

    fetchData();

      // Cleanup function to abort the request when the component unmounts or dependencies change
      return () => {
          isMounted = false; // Prevent state updates if component is unmounted
          controller.current.abort(); // Abort the ongoing request if dependencies (dates) change
          console.log('aborted');
      };

  }, [props.startDate, props.endDate, props.productId]);


  if (loading) {
    return (
    <div className={'text-black-50'} style={{marginRight: "1em"}}>
        {window.translations.loading}
    </div>
          );
  }

  if (price === false) {
    return (
    <div className={'text-black-50'} style={{marginRight: "1em"}}>
        {window.translations.noPrice}
    </div>
          );
  }

  let priceDisplay = price;
  if (displayUnit) {
    priceDisplay = price + " / " + displayUnit;
  }
  if (vatMode) {
    priceDisplay += " " + (vatMode === 'include' ? window.translations.priceWithVat : window.translations.priceWithoutVat);
  }

  let priceVatDisplay = priceVatFormatted;
  if (displayUnit && priceVatDisplay) {
    priceVatDisplay = priceVatDisplay + " / " + displayUnit;
  }



  return (
      <div>
    <div style={{marginRight: "1em"}}>
      <br/>
      <div className={'text-end'} style={{fontSize: "1.2em", fontWeight: "bold"}}>{priceDisplay}</div>
      {vatMode && priceVatDisplay &&
      <div className={'text-end text-black-50'} style={{fontSize: "0.85em", fontWeight: emphasizeVatPrice ? "bold" : undefined}}>
        {priceVatDisplay} {vatMode === 'include' ? window.translations.priceWithoutVat : window.translations.priceWithVat}
      </div>}
      <div className={'text-black-50'} style={{fontSize: "0.8em"}}>{dateFromFormatted} - {dateToFormatted}</div>
      <br/>
    </div>
          {displayAvailableQuantities && <div className={'text-end small'} style={{marginRight: "1em"}}>
              Celkový počet kusů: {quantity.totalQuantity} <br/>
              Dostupný počet kusů: {quantity.availableQuantity}
          </div>}
      </div>
  );
}



export default ItemDatePicker;
